export const FILE_SAMPLE="/file/sample";
export const FILE_DATA="/file/data";
export const FILE_UPLOAD="/file/chunk/upload";
export const FILE_MERGE="/file/chunk/merge";
export const FILE_INFO="/file/info";